export default __webpack_public_path__ + "static/media/box.01328e77.svg";